export default "__VITE_ASSET__CLXo4mpk__"